import { getOgImages } from "@ekafyi/viteui-lib/utils";
import { NextSeo } from "next-seo";
import { SITE_META_TEXT, NOTES_META_TEXT } from "../../public/shared-assets/texts";

type PageSeoProps = {
  path: string;
  title: string;
  appendTitle?: string;
  description?: string;
  ogSubtitle?: string;
};

const BASE_URL = process.env.NEXT_PUBLIC_URL;

// -----

export const PageSeo = ({ path, title, appendTitle, description, ogSubtitle }: PageSeoProps) => {
  if (title) {
    const canonical = path ? `${BASE_URL}${path}` : undefined;
    const fullTitle = `${title}${appendTitle ? ` | ${appendTitle}` : ""}`;

    const ogData = getOgImages({
      path: path.split("/")[1],
      title,
      subtitle: ogSubtitle || description,
      ogUrl: `${BASE_URL}/api/social-card`,
    });

    return (
      <NextSeo
        title={fullTitle}
        description={description}
        canonical={canonical}
        openGraph={{ url: canonical, images: ogData }}
      />
    );
  }
  return null;
};

// -----

type NotesPageSeoProps = {
  activeData?: {
    title: string;
    slug: string;
    excerpt?: string;
  };
};

export const NotesPageSeo = ({ activeData }: NotesPageSeoProps) => {
  const NOTES_BASE_PATH = "/notes";
  if (!activeData) {
    return (
      <PageSeo
        path={NOTES_BASE_PATH}
        title={NOTES_META_TEXT.title}
        description={NOTES_META_TEXT.description}
        ogSubtitle={NOTES_META_TEXT.imageTexts.description}
      />
    );
  }
  const seoData = {
    path: `${NOTES_BASE_PATH}/${activeData.slug}`,
    title: activeData.title,
    appendTitle: NOTES_META_TEXT.title,
    description: activeData.excerpt?.length ? activeData.excerpt : undefined,
    ogSubtitle: activeData.excerpt?.length ? activeData.excerpt : undefined,
  };
  return <PageSeo {...seoData} />;
};

// -----

export const HomePageSeo = () => {
  const ogData = getOgImages({
    title: SITE_META_TEXT.imageTexts.title,
    subtitle: SITE_META_TEXT.imageTexts.description,
    ogUrl: `${BASE_URL}/api/social-card`,
  });
  return (
    <NextSeo
      title={SITE_META_TEXT.title}
      description={SITE_META_TEXT.description}
      canonical={BASE_URL}
      openGraph={{ url: BASE_URL, images: ogData }}
    />
  );
};
